<span>{{ title | translate | uppercase }}</span>
{{ time | numbertotime }}
